import React from 'react';
import { Layers3, Coffee, Sparkles } from 'lucide-react';

/**
 * CategoryFilter — Phase 4 replacement for ContextModeToggle.
 *
 * 3 pills: All · Everyday Basics · Food / Ordering.
 * Persists nothing here; parent owns state + localStorage.
 */
const OPTIONS = [
  { value: 'all', label: 'All', Icon: Sparkles },
  { value: 'everyday_basics', label: 'Everyday Basics', Icon: Layers3 },
  { value: 'food_ordering', label: 'Food / Ordering', Icon: Coffee },
];

export default function CategoryFilter({ value, onChange }) {
  return (
    <div
      className="sv-category-filter sv-glass"
      role="radiogroup"
      aria-label="Sign category filter"
      data-testid="category-filter"
    >
      {OPTIONS.map(({ value: v, label, Icon }) => (
        <button
          key={v}
          type="button"
          className={`sv-category-opt ${value === v ? 'active' : ''}`}
          onClick={() => onChange(v)}
          role="radio"
          aria-checked={value === v}
          data-testid={`category-${v}`}
        >
          <Icon className="w-3.5 h-3.5" />
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
}
